import React from "react"
import { Link } from "gatsby"
import clsx from "clsx"
import { formatDate } from "../../../utils/date"

type Category = {
  name: string
  slug: string
}

type ArticleCardProps = {
  title: string
  slug: string
  cover?: string
  className?: string
  imagePriority?: "high" | "low" | "auto"
  loading?: "eager" | "lazy"
  categories: Category[]
  date: string
}

export default function FeaturedArticleCard({
  title,
  cover,
  slug,
  className,
  imagePriority,
  loading = "lazy",
  categories,
  date,
}: ArticleCardProps) {
  return (
    <div className={clsx("block w-full h-full relative", className)}>
      <div className="relative w-full rounded-2xl sm:h-full h-[424px] overflow-hidden group">
        <img
          src={
            cover ||
            "https://uploads.sitepoint.com/wp-content/uploads/2023/08/1692781397fallback.svg"
          }
          alt={title}
          loading={loading}
          className="w-full h-full object-cover"
          fetchpriority={imagePriority}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C0E] to-transparent transition-opacity group-hover:bg-opacity-40" />
        <Link className="absolute inset-0" to={`/${slug}/`} />

        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="flex flex-col gap-6">
            <Link to={`/${slug}/`}>
              <span className="text-jar-6 font-medium max-w-[374px]">
                {title}
              </span>
            </Link>
            <div className="flex gap-1.5 text-jar-3 flex-wrap">
              <p className="text-[#B2B3BD]">Published in</p>
              <span className=" text-[#B2B3BD]">·</span>

              {categories?.map((category, index) => (
                <React.Fragment key={category.slug}>
                  <Link to={`/${category.slug}`}>
                    <span className="text-jar-3 border-b border-white text-white hover:text-[#f0f1feba] hover:border-[#f0f1feba]">
                      {category.name}
                    </span>
                  </Link>

                  {index < categories.length - 1 && (
                    <span className="text-jar-3 text-[#B2B3BD]">·</span>
                  )}
                </React.Fragment>
              ))}
              <span className="text-jar-3 text-[#B2B3BD]">·</span>
              <p className="text-jar-3 text-[#B2B3BD]">{formatDate(date)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
